import { LicenseManager } from 'ag-grid-enterprise';
import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { log } from '@/utils/core/vueLogger';

const LICENSE_RETRY_DELAY_MS = 500;
const LICENSE_MAX_ATTEMPTS = 120;

let iframeListenerIntervalId = null;
let licensePollIntervalId = null;
let licenseAttemptCount = 0;
let isLicenseApplied = false;
let isIframeLoadBound = false;

function getAgGridLicenseKey() {
	const envLicenseKey = import.meta.env.VITE_AG_GRID_LICENSE_KEY?.trim();
	if (envLicenseKey) {
		return envLicenseKey;
	}

	return iframeDataBridge.getIframeWindow()?.externis?.licag || iframeDataBridge.getExternis(false)?.licag || '';
}

function stopLicensePolling() {
	if (licensePollIntervalId) {
		window.clearInterval(licensePollIntervalId);
		licensePollIntervalId = null;
	}
}

function stopIframeListenerPolling() {
	if (iframeListenerIntervalId) {
		window.clearInterval(iframeListenerIntervalId);
		iframeListenerIntervalId = null;
	}
}

function applyAgGridEnterpriseLicense() {
	if (isLicenseApplied) {
		return true;
	}

	const licenseKey = getAgGridLicenseKey();
	if (!licenseKey) {
		return false;
	}

	LicenseManager.setLicenseKey(licenseKey);
	isLicenseApplied = true;
	stopLicensePolling();
	stopIframeListenerPolling();
	log('success', 'agGridEnterprise', 'AG Grid Enterprise license applied');
	return true;
}

function startLicensePolling(resetAttempts = false) {
	if (isLicenseApplied) {
		return;
	}

	if (resetAttempts) {
		licenseAttemptCount = 0;
	}

	if (applyAgGridEnterpriseLicense() || licensePollIntervalId) {
		return;
	}

	licensePollIntervalId = window.setInterval(() => {
		if (applyAgGridEnterpriseLicense()) {
			return;
		}

		licenseAttemptCount += 1;
		if (licenseAttemptCount >= LICENSE_MAX_ATTEMPTS) {
			stopLicensePolling();
			log('warn', 'agGridEnterprise', 'AG Grid Enterprise license key not found yet');
		}
	}, LICENSE_RETRY_DELAY_MS);
}

function bindIframeLoadListener() {
	if (typeof window === 'undefined' || isIframeLoadBound || isLicenseApplied) {
		return;
	}

	const bindLoadListener = () => {
		const iframe = iframeDataBridge.getIframe();
		if (!iframe) {
			return false;
		}

		iframe.addEventListener('load', () => {
			startLicensePolling(true);
		});

		isIframeLoadBound = true;
		stopIframeListenerPolling();

		return true;
	};

	if (bindLoadListener()) {
		return;
	}

	iframeListenerIntervalId = window.setInterval(() => {
		bindLoadListener();
	}, LICENSE_RETRY_DELAY_MS);
}

export function initializeAgGridEnterprise() {
	if (typeof window === 'undefined') {
		return;
	}

	if (applyAgGridEnterpriseLicense()) {
		return;
	}

	bindIframeLoadListener();
	startLicensePolling(true);
}
